import { getWalletConnectConnector, Wallet } from '@rainbow-me/rainbowkit';

type BurritoOptions = {
  projectId: string;
};

export const burritoWallet = ({ projectId }: BurritoOptions): Wallet => ({
  id: 'burrito',
  name: 'Burrito',
  iconUrl: '/images/burrito.png',
  iconBackground: '#fff',
  downloadUrls: {
    android: 'https://play.google.com/store/apps/details?id=com.burritowallet.app',
    ios: 'https://apps.apple.com/us/app/burrito-wallet-crypto-wallet/id6449563083',
    mobile: 'https://www.burritowallet.com/en',
    qrCode: 'https://www.burritowallet.com/en',
  },
  mobile: {
    getUri: (uri: string) => `burrito://wc?uri=${encodeURIComponent(uri)}`,
  },
  qrCode: {
    getUri: (uri) => uri,
    instructions: {
      learnMoreUrl: 'https://www.burritowallet.com/en',
      steps: [
        {
          description:
            'We recommend putting Burrito on your home screen for faster access to your wallet.',
          step: 'install',
          title: 'Open the Burrito Wallet app',
        },
        {
          description: 'You can easily backup your wallet using our backup feature on your phone.',
          step: 'create',
          title: 'Create or Import a Wallet',
        },
        {
          description: 'Tap the WalletConnect button',
          step: 'scan',
          title: 'After you scan, a connection prompt will appear for you to connect your wallet.',
        },
      ],
    },
  },
  createConnector: getWalletConnectConnector({ projectId }),
});
